export const basketRoutes = {
  'route.basket.index': '/products/basket',

  'api.basket.data': 'shop/basket/current',
  'api.basket.add': 'shop/basket/add',
  'api.basket.remove': 'shop/basket/remove',
  'api.basket.remove-all': 'shop/basket/remove-all',
  'api.basket.finalize': 'shop/basket/finalize/[id]',
};
